<script>
import Vue from 'vue';
import ResourceSelect from '~/components/ResourceSelect/ResourceSelect.vue';
import Organization from '~/models/Organization';

export default Vue.extend({
  extends: ResourceSelect,

  props: {
    getOptionLabel: {
      type: Function,
      required: false,
      default: (resource) => resource.name,
    },

    query: {
      type: Object,
      required: false,
      default: () => new Organization(),
    },
  },

  methods: {
    fetch() {
      return this.query.$all();
    },
  },
});
</script>
